import React, { useEffect, useState } from "react";
import { ConfigProvider, Table, message } from "antd";
import DashboardProvider from "../../../../../../shared/provider/DashboardProvider";
import { IdeaWithEvaluationAndWithoutTreatmentDTO } from "../../../../../../shared/dto/DashboardLastTenHighScoreDto";
import ptBR from "antd/lib/locale/pt_BR";

const columns = [
  {
    title: 'ID',
    dataIndex: 'ideaId',
    key: 'ideaId',
    sorter: (a: IdeaWithEvaluationAndWithoutTreatmentDTO, b: IdeaWithEvaluationAndWithoutTreatmentDTO) => a.ideaId - b.ideaId,
  },
  {
    title: 'Nome',
    dataIndex: 'ideaTitle',
    key: 'ideaTitle',
    sorter: (a: IdeaWithEvaluationAndWithoutTreatmentDTO, b: IdeaWithEvaluationAndWithoutTreatmentDTO) => a.ideaTitle.localeCompare(b.ideaTitle),
  },
  {
    title: 'Nota',
    dataIndex: 'score',
    key: 'score',
    sorter: (a: IdeaWithEvaluationAndWithoutTreatmentDTO, b: IdeaWithEvaluationAndWithoutTreatmentDTO) => a.score - b.score,
    render: (score: number) => score.toFixed(2),
  },
  {
    title: 'Dias desde a avaliação',
    dataIndex: 'daysAfterEvaluation',
    key: 'daysAfterEvaluation',
    sorter: (a: IdeaWithEvaluationAndWithoutTreatmentDTO, b: IdeaWithEvaluationAndWithoutTreatmentDTO) => a.daysAfterEvaluation - b.daysAfterEvaluation,
    render: (days: number) => `${days} dias`,
  },
];

function TopIdeasWithEvaluationList({ dataUpdater }: {dataUpdater: React.Dispatch<React.SetStateAction<IdeaWithEvaluationAndWithoutTreatmentDTO[]>>}): JSX.Element {
  const [data, setData] = useState<IdeaWithEvaluationAndWithoutTreatmentDTO[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const dashboardProvider = new DashboardProvider();
      try {
        const response = await dashboardProvider.getTopIdeasWithEvaluationAndWithoutTreatment();
        setData(response);
      } catch (error) {
        message.error("Erro ao buscar dados de ideias com avaliação e sem tratamento");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    dataUpdater(data);
  }, [data, dataUpdater]);

  return (
    <ConfigProvider locale={ptBR}>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={false}
        rowKey="ideaId"
        />
    </ConfigProvider>
  );
}

export default TopIdeasWithEvaluationList;
